import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../components/controls/inputs";
import BaseCreator from "../../../components/creators/baseCreator";
import { useForm } from "../../../system/hooks/useForm";
import GridWrapper from '../../../components/controls/GridWrapper';
import GridSelectorInput from '../../../components/controls/GridSelectorInput';
import { ContractorSelectorModal } from '../../Dictionaries/Contractor';
import { IEntitySimpleDTO } from '../../../libs/coreapi-dto/@types/common';
import { ILabelPrintScenarioDTO } from '../../../libs/coreapi-dto/dirs/labelPrintScenario';
import { LabelScenarioItemEdit } from "./LabelScenarioItemEdit";
import { useUserContext } from "../../../system/providers/userContextProvider";

interface IValidator {
    name: string,
    contractor: IEntitySimpleDTO
}

export const LabelPrintScenarioCreatorModal: FC<ICreatorModalProps<ILabelPrintScenarioDTO>> = (props) => {
    const [entity, setEntity] = useState<ILabelPrintScenarioDTO>(props.data ?? {} as ILabelPrintScenarioDTO);
    const [contractor, setContractor] = useState(props.data?.contractor as IEntitySimpleDTO);

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.labelPrintScenario.' + value)
    const errorsT = (value: string) => t('errors.' + value);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [data, setData] = useState<Array<IEntitySimpleDTO>>([]);
    const userContext = useUserContext();
    const isSuperUser = userContext.userRoles.includes('SuperUser');
    const isAdministrator = userContext.userRoles.includes('Administrator');

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            name: {
                required: {
                    value: entity.name ? false : true,
                    message: errorsT("required")
                }
            },
            contractor: {
                required: {
                    value: contractor ? false : true,
                    message: errorsT("required")
                }
            }
        }
    });

    const handleSubmit = () => {
        const canSave = isValid()
        if (canSave) {
            if (data) {

            }
            props.save({ ...entity, contractor: contractor, items: [...data] })
            setIsSubmitting(true)
        }
    }

    return <>
        <BaseCreator
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            valid={!props.lockFromPermission}
        >
            <GridWrapper cols={2}>
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('name')}
                    value={entity.name} error={errors.name}
                    onChange={(value) => setEntity({ ...entity, name: value })}
                    onFocus={() => setErrors({ ...errors, name: undefined })}
                    disabled={props.lockFromPermission}
                />
                <GridSelectorInput
                    required
                    disabledInput={true}
                    id='idContractorGlobal'
                    selectorModalJsx={ContractorSelectorModal}
                    label={baseT('contractor')}
                    selectedEntity={contractor}
                    onSelect={(entity1) => setContractor(entity1)}
                    error={errors.contractor} onFocus={() => setErrors({ ...errors, contractor: undefined })}
                    disabled={props.lockFromPermission}
                    applyUserFilter={!(isAdministrator || isSuperUser)}
                />
            </GridWrapper>
            <LabelScenarioItemEdit
                data={entity}
                setData={(value) => setData([...value])}
            />
        </BaseCreator>
    </>
}